import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import ManualPageTable from 'App/components/ManualPageTable';
import pathOrDash from 'App/utils/pathOrDash';
import propOrDash from 'App/utils/propOrDash';
import { TextInput } from 'Shared/form/TextField';
import useFetchContentGroups from '../hooks/useFetchContentGroups';

dayjs.extend(timezone);

const NameCell = ({ row }) => {
    return <Link to={`/content-library/content-group/${row.original.uuid}`}>{row.original.name}</Link>;
};

NameCell.propTypes = {
    row: PropTypes.shape({
        original: PropTypes.shape({
            name: PropTypes.string,
            uuid: PropTypes.string,
        }),
    }).isRequired,
};

const ContentLibraryTable = ({ selectedTab }) => {
    const [filterParams, setFilterParams] = useState({
        limit: 10,
        page: 1,
        sortKey: 'name',
        sortOrder: 'asc',
        timezone: dayjs.tz.guess(),
    });
    const { isFetching, data, totalCount } = useFetchContentGroups(selectedTab, filterParams);

    const onPageChange = ({ pageIndex, pageSize }) => {
        setFilterParams((prev) => ({
            ...prev,
            limit: pageSize,
            page: pageIndex,
        }));
    };

    const onSortChange = (sort) => {
        setFilterParams((prev) => ({
            ...prev,
            ...sort,
            page: 1,
        }));
    };

    const onFilterChange = (e) => {
        setFilterParams((prev) => ({
            ...prev,
            [e.target.name]: e.target.value,
            page: 1,
        }));
    };

    const columns = [
        {
            Header: 'Name',
            accessor: 'name',
            id: 'name',
            Cell: NameCell,
            canSort: true,
            canFilter: true,
            Filter: (
                <TextInput
                    name="name"
                    placeholder="Filter by Name"
                    onChange={onFilterChange}
                    size="sm"
                />
            ),
        },
        {
            Header: 'Last Updated',
            id: 'updated_on',
            accessor: propOrDash('updatedOn'),
            canSort: true,
            canFilter: true,
            Filter: (
                <TextInput
                    name="updatedOn"
                    placeholder="Filter by Last Updated"
                    onChange={onFilterChange}
                    size="sm"
                />
            ),
        },
        {
            Header: 'Updated By',
            id: 'updatedByUser',
            accessor: pathOrDash(['updatedByUser', 'fullName']),
            canSort: true,
            canFilter: true,
            Filter: (
                <TextInput
                    name="updatedByUser"
                    placeholder="Filter by Updated By"
                    onChange={onFilterChange}
                    size="sm"
                />
            ),
        },
    ];

    return (
        <ManualPageTable
            columns={columns}
            data={data}
            totalRows={totalCount}
            isLoading={isFetching}
            onPageChange={onPageChange}
            currentPage={filterParams.page}
            onSortChange={onSortChange}
            initialSortKey={filterParams.sortKey}
            initialSortOrder={filterParams.sortOrder}
        />
    );
};

ContentLibraryTable.propTypes = {
    selectedTab: PropTypes.string.isRequired,
};

export default ContentLibraryTable;
